// extracted by mini-css-extract-plugin
export default {"footerCard":"Card_footerCard__m1Ah4"};